
import {dispatchTelegramConnectIntent, dispatchGetUserProfile} from "@/store/main/actions";
import { Component, Vue, Prop } from "vue-property-decorator";
import UiSmallLoader from "@/components/Main/Ui/UiSmallLoader.vue";
import { ITGConnectPreview } from '@/interfaces/index.js'
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faInfo,
  faInfoCircle,
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faInfo,
  faInfoCircle,
);

interface IIntent {
    id: number;
    scope: "single" | "group";
    telegram_link: string;
    expires_at: Date;
    affected_user_ids: number[]
    }

@Component({
  components:{
    UiSmallLoader
  }
})

export default class ChangeTGModal extends Vue {
  @Prop({ required: true }) readonly modalShow!: boolean;
    @Prop({required: true }) readonly preview!: ITGConnectPreview

    public loadingCreatingIntent: boolean = false;
     public selectedScope: "single" | "group" | null = null;
    public isLink_ready: boolean = false;
    public isError: boolean = false;
    public errorText: string = '';
    public intent: IIntent | null = null;

    get canChangeSingle(): boolean {
    return this.preview?.can_change_single ?? false;
  }

  get canChangeGroup(): boolean {
    return this.preview?.can_change_group ?? false;
  }

  async handleScopeSelect(scope: 'single' | 'group') {
     this.selectedScope = scope;
    this.loadingCreatingIntent = true;
    this.isError = false;
    this.errorText = "";
    try {
      const response = await dispatchTelegramConnectIntent(this.$store, { scope });
      if (response?.data) {
        this.intent = response.data;
        this.isLink_ready = true;
        setTimeout(() => {
          dispatchGetUserProfile(this.$store);
        }, 5000);
        window.open(response.data.telegram_link, "_blank", "noopener,noreferrer");
      } else {
        this.isError = true;
        this.errorText = String(this.$t('Failed to create link'));
      }
    } catch (error) {
      this.isError = true;
      const status = error?.response?.status;
      if (status === 404) {
        this.errorText = String(this.$t("no active Telegram"));
      } else if (status === 409) {
        this.errorText = String(this.$t('Telegram is busy'));
      } else if (status === 410) {
        this.errorText = String(this.$t('time limit has expired'));
      } else {
        this.errorText = String(this.$t('Please try again'));
      }
    } finally {
      this.loadingCreatingIntent = false;
    }
  }

   get formattedExpiresAt(): string {
    if (!this.intent) return '';
    return new Date(this.intent.expires_at).toLocaleString('ru-RU');
  }

  resetToSelect() {
    this.isLink_ready = false;
    this.isError = false;
    this.errorText = "";
    this.selectedScope = null;
    this.intent = null;
  }


  public handleClose() {
    this.resetToSelect();
    this.$emit("close-modal");
  }
}
